var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{staticStyle:{"float":"right"}},[_c('a',{attrs:{"href":_vm.vosLink,"target":"_blank"}},[_c('i',{staticClass:"el-icon-money text-white"}),_vm._v(" Recharge ")])])}
var staticRenderFns = []

export { render, staticRenderFns }